<template>
	<div class="shopList content-box">
		<div class="mb-10">
			<p>{{ detailsObj.group_name }}</p>
		</div>
		<div class="multi-table">
			<div class="flex flex-align-center flex-just-between">
				<div class="flex flex-align-center">
					<div class="flex flex-align-center mr-20">
						<div class="ml-14 mr-18">
							<el-checkbox @change="checkeFun" v-model="allChecked">当页全选</el-checkbox>
						</div>
						<span class="fz-14 yx-color-text-regular mr-10">已选 {{ selectionShopArr.length }}</span>
						<el-tooltip :disabled="!!selectionShopArr.length" content="请先选择商品" placement="top">
							<el-button v-if="$auth.hasPermi('system:goods:sampleRequest')" type="primary" @click="batchSample">批量申样</el-button>
						</el-tooltip>
						<el-tooltip
							v-if="$auth.hasPermi('system:goods:unsample-broadcasting')"
							:disabled="!!selectionShopArr.length"
							content="请先选择商品"
							placement="top"
						>
							<el-button @click="unlimitedBroadcasting">无样开播</el-button>
						</el-tooltip>
						<el-tooltip
							:content="$isSp(platformId) ? '视频号暂未开放' : '请先选择商品'"
							:disabled="$isSp(platformId) ? false : !!selectionShopArr.length"
							placement="top"
						>
							<el-button v-if="$auth.hasPermi('system:goods:promote')" @click="recommend" type="primary">推荐商品给达人</el-button>
						</el-tooltip>
					</div>
				</div>
				<div>
					<export-list
						v-if="$auth.hasPermi('system:shopLibrary:export')"
						ref="exportList"
						:routerPath="routerPath"
						:platformId="platformId"
						:exportInterface="exportInterface"
						:exportDialog="exportDialog"
						:isExportImg="true"
					></export-list>
				</div>
			</div>
			<multi-table
				v-loading="loading"
				class="mt-12"
				ref="multiTable"
				:selectionChange="selectionChange"
				:columns="filterColumns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
			></multi-table>
		</div>
		<remark-dialog ref="remarkDialog" @saveRemark="saveRemark"></remark-dialog>
		<editShop-dialog ref="editShopDialog" @refreshList="refreshList"></editShop-dialog>
		<handCard-dialog ref="handCardDialog" @refreshList="refreshList"></handCard-dialog>
		<shareDrawer ref="shareDrawer" :key="timer"></shareDrawer>
		<!-- <join ref="join"></join> -->
		<recommendDrawer ref="recommendDrawer" :platformId="platformId"></recommendDrawer>
		<tagDialog ref="tagDialog" @refreshList="refreshList"></tagDialog>
		<EditSampleRuleDialog :platformId="platformId" @refresh="refreshList"></EditSampleRuleDialog>
		<!-- 批量申样 -->
		<apply-sample-drawer ref="applySampleDrawer" :platformId="platformId" @refreshList="refreshList" />

		<!--无样开播-->
		<sample-free-broadcast-drawer ref="sampleFreeBroadcastDrawer" :platformId="platformId" @refreshList="refreshList" />
	</div>
</template>
<script>
import getColums from './columns';
import remarkDialog from '@/views/shopManage/components/remarkDialog.vue';
import editShopDialog from '@/views/shopManage/components/editShopDialog.vue';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
import recommendDrawer from '@/views/shopManage/components/recommendDrawer';
import exportList from '@/views/common/exportList';
import { editProduct, editField, shopGroupList, shopGroupDetail, removeGroup, productInfoExport } from '@/api/shopManage';
import { mapState, mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
// import join from '@/views/common/dialog/join.vue';
import { promoteStatus } from '@/utils/dataMap';
import shareDrawer from '@/views/common/dialog/shareDrawer.vue';
import { arrSort } from '@/utils/common';
import tagDialog from '@/components/business/tagDialog';
import EditSampleRuleDialog from '@/modules/sample/apply/rules/editDialog';
import applySampleDrawer from '@/components/business/applySampleDrawer';
export default {
	name: 'shopList',
	components: {
		remarkDialog,
		editShopDialog,
		handCardDialog,
		// join,
		shareDrawer,
		recommendDrawer,
		exportList,
		tagDialog,
		EditSampleRuleDialog,
		applySampleDrawer,
		sampleFreeBroadcastDrawer: () => import('@/components/business/sampleFreeBroadcastDrawer'),
	},
	data() {
		return {
			list: [],
			options: {
				selectable: true,
			},
			total: '0',
			selectionShopArr: [],
			detailsObj: {},
			platformId: '',
			params: {
				page_index: 1,
				page_size: 10,
			},
			promoteStatus,
			timer: '',
			filterArr: [],
			allChecked: '',
			routerPath: '/shopManage/shopLibrary/record',
			ids: [],
			loading: false,
		};
	},
	computed: {
		...mapState(['vuex_shopId', 'vuex_userInfo']),
		...mapGetters(['isDrPartnerDataView']),
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		filterColumns() {
			let newArr = getColums(this).filter(val => val.isShow);
			return newArr;
		},
	},
	created() {
		let group_id = this.$route.query.groupId;
		this.groupId = group_id ? group_id : this.vuex_shopId;
		this.platformId = +this.$route.query.platformId || 1;
		this.$store.commit(types.SHOP_ID, this.groupId);
		this.getShopList();
		this.getShopsDetails();
	},
	methods: {
		sizeChange() {},
		//商品组详情
		async getShopsDetails() {
			const { code, data } = await shopGroupDetail({ group_id: this.groupId });
			if (code == 0) {
				this.detailsObj = data[0];
			}
		},
		//商品列表
		async getShopList() {
			this.loading = true;
			this.params.group_id = this.groupId;
			try {
				const { code, data } = await shopGroupList(this.params);
				if (code == 0)
					this.list = data.list.map(item => {
						return {
							...item,
							sortOrder: item.sort_order,
							group_id: this.groupId,
							operations: this.getButtons(item),
						};
					});
				this.total = data.page.item_total + '';
			} finally {
				this.loading = false;
			}
		},
		//选中值
		checkeFun(e) {
			this.setTableCheckList(this.list, e);
		},
		setTableCheckList(list, e) {
			this.$refs.multiTable.toggleSelection(this.list, false);
			this.$refs.multiTable.toggleSelection(list, e);
		},
		unlimitedBroadcasting() {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) return;
			if (selectionShopArr.length > 10) return this.$message.warning('最多选择10个商品');
			this.$refs.sampleFreeBroadcastDrawer.show(selectionShopArr, 'multiple');
		},
		currentChange() {},
		//操作按钮
		getButtons(item) {
			const arr = [];
			arr.push(
				{
					label: '推广商品',
					type: 'text',
					isShow: this.$auth.hasPermi('system:goods:promote'),
					classtype: 2,
					click: row => {
						this.timer = new Date().getTime();
						this.$nextTick(() => {
							this.$refs.shareDrawer.show(row);
						});
					},
				},
				{
					label: item.promote_status === this.promoteStatus.open ? '关闭推广' : '开启推广',
					type: 'text',
					isShow: this.$auth.hasPermi('system:goods:extend'),
					classtype: item.promote_status == this.promoteStatus.open ? this.promoteStatus.open : this.promoteStatus.close,
					notSelf: !item.is_self,
					click: row => {
						if (row.is_self) {
							this.extension(row);
						}
					},
				},
				{
					label: '无样开播',
					type: 'text',
					isShow: this.$auth.hasPermi('system:goods:unsample-broadcasting'),
					classtype: 2,
					click: row => {
						this.$refs.sampleFreeBroadcastDrawer.show([row], 'fast');
					},
				},
				{
					label: '快速申样',
					type: 'text',
					isShow: item.other_status === 1 && this.$auth.hasPermi('system:goods:sampleRequest'),
					classtype: 2,
					click: row => {
						this.$refs.applySampleDrawer.show([row], 'fast', row.product_type === '4');
					},
				},
				{
					type: 'copyLink',
					isShow: true,
				},
				{
					label: '查看详情',
					type: 'text',
					isShow: this.$auth.hasPermi('system:shopGroup:shopDetails-query'),
					classtype: 2,
					click: row => {
						let handLink = this.$router.resolve({
							path: '/shopManage/shopGroup/detail/shopDetails',
							query: {
								productId: row.product_id,
								thirdProductId: row.third_product_id,
								platformId: row.platform_id,
							},
						});
						window.open(handLink.href, '_blank');
					},
				},
				{
					label: '编辑商品机制',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:goods:editGoods-mechanism'),
					notSelf: !item.is_self,
					click: row => {
						if (row.is_self) {
							this.$refs.editShopDialog.editShop(row);
						}
					},
				},
				{
					label: item.hand_card ? '查看手卡' : '上传手卡',
					type: 'text',
					classtype: 2,
					isShow: !item.hand_card ? this.$auth.hasPermi('system:view-uploadHandCard') : true,
					notSelf: !item.hand_card || !item.is_self,
					click: row => {
						if (row.is_self || item.hand_card) {
							item.hand_card ? this.$refs.handCardDialog.seeHandCard(row) : this.$refs.handCardDialog.handCard(row);
						}
					},
				},
				{
					label: '备注',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:goods-remark'),
					notSelf: !item.is_self,
					click: row => {
						if (row.is_self) {
							this.$refs.remarkDialog.remark(row);
						}
					},
				},
				{
					label: '移除',
					type: 'text',
					classtype: 1,
					isShow: true,
					click: row => {
						let params = {
							group_id: this.groupId,
							product_ids: row.product_id,
						};
						this.$confirm('确认删除吗', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(async () => {
							const { code } = await removeGroup(params);
							if (code == 0) {
								this.$message.success('移除成功');
								this.getShopList();
							}
						});
					},
				},
				{
					label: '修改申样门槛',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:goods-editSill'),
					notSelf: !((this.$auth.hasPermi('system:goods-editSill') && item.is_self) || this.$auth.hasPermi('system:goods-editSill')),
					tooltipContent: this.$auth.hasPermi('system:goods-editSill') ? '限招商运营本人/管理员可编辑' : '',
					click: row => this.$auth.hasPermi('system:goods-editSill') && item.is_self && this.$Bus.$emit('show', { mode: 'single', goods: [row] }),
				},
			);
			let filterArr = arr.filter(item => item.isShow);
			filterArr.tagDialog = this.addTag;
			filterArr.getList = this.getShopList;
			return filterArr;
		},
		accountReset() {},
		//提交备注
		async saveRemark(val) {
			let params = {
				product_id: val.product_id,
				remark: val.remark,
			};
			const { code } = await editField(params);
			if (code == 0) {
				this.$message.success('修改成功');
				this.getShopList();
				this.$refs.remarkDialog.dialogRemarksVisible = false;
			}
		},
		//上传商品机制
		async saveEditShop(val) {
			const { code } = await editProduct(val);
		},
		//刷新列表
		refreshList() {
			this.getShopList();
		},
		//推广
		async extension(val) {
			let params = {
				product_id: val.product_id,
				promote_status: val.promote_status === this.promoteStatus.open ? this.promoteStatus.close : this.promoteStatus.open,
			};
			if (val.promote_status === this.promoteStatus.open) {
				this.$confirm('确认关闭推广吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(async () => {
					const { code } = await editField(params);
					if (code == 0) this.$message.success('关闭成功');
					this.getShopList();
				});
			} else {
				const { code } = await editField(params);
				if (code == 0) this.$message.success('开启成功');
				this.getShopList();
			}
		},
		batchSample() {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) return;
			const isCommander = selectionShopArr.filter(item => item.product_type === '4').length; //是否含有二级团长商品
			this.$refs.applySampleDrawer.show(this.selectionShopArr, 'multiple', !!isCommander);
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
			this.ids = val.map(item => item.product_id);
			const selectLength = this.selectionShopArr.length;
			this.allChecked = selectLength && selectLength === this.list.length;
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getShopList();
		},
		addAccount() {},
		async exportInterface(that) {
			that.$refs.exportDialog.show(this.exportDialog);
		},
		async exportDialog(value) {
			const { platformId: platform_id, routerPath } = this;
			const { code } = await productInfoExport({ platform_id, type: 3, ...this.params, export_img: Number(value), ids: this.ids });
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
		recommend() {
			let arr = JSON.parse(JSON.stringify(this.selectionShopArr));
			let list = arrSort(arr, 'total_sales');
			this.$refs.recommendDrawer.show(list, 1);
		},
		addTag(row) {
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
	},
};
</script>
<style scss="less" scoped>
.btn-box {
	display: flex;
	padding: 20px 0;
	align-items: center;
}

.shop-mount {
	padding: 10px;
	border: 6px;
	display: flex;
	justify-content: space-around;
	background-color: #f8f8f8;
}

.shops {
	display: flex;
}
</style>
